import Script from 'next/script'

import { getEntity, getFooterData, getHeaderData } from '@api/index'

import { default as normalizeBlog } from '@models/Blog'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeHeaderData } from '@models/Header'
import normalizeMetadata from '@models/Metadata'

import Breadcrumb from '@/molecules/Breadcrumb'
import { BlogList, SectionBuilder } from '@/organisms'

import Layout from '@/organisms/Layout'

import { newsletterScript } from '@utils/scripts/newsletter-script'

export const getStaticProps = async ({ params }) => {
  const [header, footer, blog] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getEntity({ entity: 'blogHome' }),
  ])
  const metadata = normalizeMetadata(blog.data.seo)

  return {
    props: {
      metadata,
      breadcrumb: normalizeBreadcrumb([{ label: 'Blog' }]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeBlog(blog.data),
    },
  }
}

const ArchiveBlog = ({
  metadata,
  header,
  footer,
  breadcrumb,
  content,
  nonce,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='white'
    >
      <Breadcrumb items={breadcrumb} />
      <BlogList
        sidebar={content.sidebar}
        posts={content.posts}
      />
      <SectionBuilder data={content.sections} />
      <Script
        id={'news-script-blog'}
        strategy={'afterInteractive'}
        nonce={`nonce-${nonce}`}
      >
        {newsletterScript}
      </Script>
    </Layout>
  )
}

export default ArchiveBlog
